'use strict';

( function ( $ ) {
	function statusSearch( e ) {
		const href = window.location.href;
		const search = window.location.search;
		if ( $( e ).is( ':checked' ) && ! $( e ).hasClass( 'active' ) ) {
			window.location.href = href + '&result=hide';
		} else {
			window.location.href = search.replace( '&result=hide', '' );
		}
	}
	$( '.search-switch' ).on( 'change', function () {
		statusSearch( $( this ) );
	} );

	if ( $( '.search-switch.active' ) ) {
		$( '.search-switch.active' ).prop( 'checked', 'checked' );
	}
} )( jQuery );
